var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "places-list col-12 md:col-8" },
    [
      _c("div", { staticClass: "mt-16 font-bold mb-6 md:mt-32" }, [
        _vm._v(_vm._s(_vm.result))
      ]),
      _c(
        "div",
        { staticClass: "row lg-gutter anim--cascad" },
        _vm._l(_vm.places, function(place) {
          return _c("card", {
            key: place.id,
            attrs: { place: place },
            on: { click: _vm.openModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "placeholder",
                  fn: function() {
                    return [_vm._t("placeholder")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        }),
        1
      ),
      _c("place-modal", {
        attrs: { place: _vm.selectedPlace, translations: _vm.translations }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }